import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBookmarkComponent } from "./med-icon-bookmark.component";

@NgModule({
  declarations: [
    MedIconBookmarkComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBookmarkComponent,
  ],
})
export class MedIconBookmarkModule { }
